<template>
  <DropDownSchemaIcon v-if="channelColor" :filled :colorClass="channelColor" />
  <div v-else class="relative flex h-4 w-4 items-center justify-center">
    <i-mdi-share
      v-if="sharedInChannel"
      class="absolute -right-0.5 -top-1 h-4 w-4 stroke-white stroke-1 text-entry-green-darker"
    ></i-mdi-share>
    <ClipboardIcon
      class="!h-4 !w-4"
      :focus
      :colorClass="colorClass || 'text-schema-own'"
      :filled
    />
  </div>
</template>

<script lang="ts" setup>
import type { EntryColor } from "~/models/IEntryColor";

withDefaults(
  defineProps<{
    channelColor?: EntryColor;
    sharedInChannel?: boolean;
    focus?: boolean;
    colorClass?: string;
    filled?: boolean;
  }>(),
  {
    sharedInChannel: false,
    channelColor: undefined,
    focus: false,
    filled: false,
    colorClass: undefined,
  }
);
</script>
